import NewAccount from "./NewAccount";

export default NewAccount;
